import { apiClient } from "../App";

/**
 * Challenge Progress Tracker
 * Auto-update daily challenges based on user activities
 */

// Update hafalan challenge progress
export async function updateHafalanProgress(ayahsCount = 1) {
  try {
    const response = await apiClient.get("/gamification/challenges/daily");
    const challenges = response.data?.challenges || [];

    // Find hafalan challenge
    const hafalanChallenge = challenges.find(
      c => c.category === "hafalan" || c.title_id?.toLowerCase().includes("hafal") || c.title_id?.toLowerCase().includes("ayat")
    );

    if (hafalanChallenge && !hafalanChallenge.completed) {
      const newProgress = Math.min(
        (hafalanChallenge.user_progress || 0) + ayahsCount,
        hafalanChallenge.target
      );

      await apiClient.post(`/gamification/challenges/daily/${hafalanChallenge.challenge_index}`, {
        progress: newProgress
      });

      return {
        success: true,
        challenge: hafalanChallenge,
        newProgress,
        completed: newProgress >= hafalanChallenge.target
      };
    }

    return { success: false, message: "No active hafalan challenge" };
  } catch (error) {
    console.error("Error updating hafalan progress:", error);
    return { success: false, error: error.message };
  }
}

// Update dzikir challenge progress
export async function updateDzikirProgress(dzikirCount = 1) {
  try {
    const response = await apiClient.get("/gamification/challenges/daily");
    const challenges = response.data?.challenges || [];

    // Find dzikir challenge
    const dzikirChallenge = challenges.find(
      c => c.title_id?.toLowerCase().includes("dzikir") || c.description_id?.toLowerCase().includes("dzikir")
    );

    if (dzikirChallenge && !dzikirChallenge.completed) {
      const newProgress = Math.min(
        (dzikirChallenge.user_progress || 0) + dzikirCount,
        dzikirChallenge.target
      );

      await apiClient.post(`/gamification/challenges/daily/${dzikirChallenge.challenge_index}`, {
        progress: newProgress
      });

      return {
        success: true,
        challenge: dzikirChallenge,
        newProgress,
        completed: newProgress >= dzikirChallenge.target
      };
    }

    return { success: false, message: "No active dzikir challenge" };
  } catch (error) {
    console.error("Error updating dzikir progress:", error);
    return { success: false, error: error.message };
  }
}

// Update reading challenge progress
export async function updateReadingProgress(pagesCount = 1) {
  try {
    const response = await apiClient.get("/gamification/challenges/daily");
    const challenges = response.data?.challenges || [];

    // Find quran reading challenge
    const quranChallenge = challenges.find(
      c => c.category === "quran" || c.title_id?.toLowerCase().includes("baca") || c.title_id?.toLowerCase().includes("quran")
    );

    if (quranChallenge && !quranChallenge.completed) {
      const newProgress = Math.min(
        (quranChallenge.user_progress || 0) + pagesCount,
        quranChallenge.target
      );

      await apiClient.post(`/gamification/challenges/daily/${quranChallenge.challenge_index}`, {
        progress: newProgress
      });

      return {
        success: true,
        challenge: quranChallenge,
        newProgress,
        completed: newProgress >= quranChallenge.target
      };
    }

    return { success: false, message: "No active quran reading challenge" };
  } catch (error) {
    console.error("Error updating reading progress:", error);
    return { success: false, error: error.message };
  }
}

// Show toast notification for challenge progress
export function showChallengeProgressToast(result, isEnglish) {
  if (!result.success) return;

  const { challenge, newProgress, completed } = result;

  if (completed) {
    // Challenge completed!
    const title = isEnglish ? challenge.title : challenge.title_id;
    return {
      type: "success",
      title: isEnglish ? "🎉 Challenge Completed!" : "🎉 Tantangan Selesai!",
      description: isEnglish
        ? `${title} - Go to Profile to claim your reward!`
        : `${title} - Buka Profil untuk mengambil hadiah!`
    };
  } else {
    // Progress updated
    const title = isEnglish ? challenge.title : challenge.title_id;
    const percentage = Math.round((newProgress / challenge.target) * 100);
    return {
      type: "info",
      title: isEnglish ? "📈 Progress Updated" : "📈 Progress Diperbarui",
      description: isEnglish
        ? `${title}: ${newProgress}/${challenge.target} (${percentage}%)`
        : `${title}: ${newProgress}/${challenge.target} (${percentage}%)`
    };
  }
}
